import { CheckActions } from 'actions'
import TextField from 'material-ui/TextField'
import FormsyText from 'formsy-material-ui/lib/FormsyText'
import Formsy from 'formsy-react'
import { Nav, Button, HelpLink } from 'components'
import KeywordTags from './KeywordTags'
import { Analytics } from 'common-frontend'

import KeywordsSurvey from './KeywordsSurvey'

const SURVEY_DISMISSED_VAL = 'dismissed'
const SURVEY_STORE_KEY = 'keyword_survey'

export default class SeoProblemsSetup extends React.Component {
  static contextTypes = {
    currentUser: React.PropTypes.object.isRequired
  }

  static propTypes = {
    check: React.PropTypes.object.isRequired
  }

  constructor(props) {
    super(props)

    this.state = {
      showSurvey: false,
      data: null,
      keywordsString: '',
      keywords: this.props.check.get('keywords').toJS()
    }

    this.updateKeywords = this.updateKeywords.bind(this)
  }

  componentWillMount() {
    Formsy.addValidationRule('isUrl', (_, value) => isURL(String(value)))
  }

  deactivate() {
    CheckActions.deactivate(this.props.check.get('checkId'))
  }

  handleFormSubmit(data) {
    if (localStorage.getItem(SURVEY_STORE_KEY) === SURVEY_DISMISSED_VAL) {
      this.submit(data)
      return
    }

    this.setState({
      showSurvey: true,
      data
    })
    localStorage.setItem(SURVEY_STORE_KEY, SURVEY_DISMISSED_VAL)
  }

  trackKeywordUpdates(e) {
    const keywordCount = this.state.keywords.length
    const keywordContent = this.state.keywords.join()

    Analytics.track('Keywords Added', {
      email: this.context.currentUser.email,
      total_keywords: keywordCount,
      keyword_content: keywordContent
    })
  }

  submit(data) {
    let keywords = this.state.keywords

    CheckActions.activate(
      this.props.check.get('key'),
      this.props.check.get('typeId'),
      { keywords, url: data.url },
      this.context.currentUser
    )
  }

  updateKeywords(payload) {
     const newState = Object.assign(this.state, {})

     newState['keywords'] = payload;
     this.setState(newState);
   }

  render() {
    const { check } = this.props
    const { showSurvey, data } = this.state
    const url = check.get('url') || this.context.currentUser.website


    return (
      <div>
        <Nav toolbarTitleText={`${check.get('name')}: Set up check`} />
        <div className="setup">
          {!showSurvey &&
            <div className="setup__form-container">
              <Formsy.Form onValidSubmit={::this.handleFormSubmit}>
                <div>
                  <div>
                    <h2 className="setup__form-heading">Set up Your SEO problems Check</h2>
                    <h4 className="setup__form-field-title">What is your website URL?</h4>
                    <FormsyText
                      name='url'
                      defaultValue={url}
                      required
                      className="setup__form-field"
                      hintText="Enter your website URL"
                      fullWidth={true}
                    />
                  </div>
                  <div>
                    <h4 className="setup__form-field-title">What keywords do you want to target?</h4>
                    <p className="body2 setup__form-field-instructions">The more specific the better: 'stock photo t-shirts' is much better than just 't-shirts'</p>
                    <p className="body2 medium-spacing2--top">For example:</p>
                    <ul className="small-spacing2--top large-spacing--bottom">
                      <li><p className="body2 setup__form-field-instructions">stock photos t-shirts</p></li>
                      <li><p className="body2 setup__form-field-instructions">cliche t-shirts</p></li>
                      <li><p className="body2 setup__form-field-instructions">tees for designers</p></li>
                    </ul>
                    <ul className="icon-font-list">
                      <HelpLink
                        title="New to keywords? Read this intro guide to keyword research"
                        url="https://moz.com/beginners-guide-to-seo/keyword-research"
                      />
                    </ul>
                    <KeywordTags
                      handleState={this.updateKeywords}
                      keywords={this.state.keywords}
                    />
                  </div>
                </div>
                <Button
                  type='Submit'
                  buttonType="primary"
                  label='Save and view my results'
                  onClick={::this.trackKeywordUpdates}
                />
              </Formsy.Form>
            </div>
          }
          {showSurvey &&
            <div className="setup__survey-container">
              <KeywordsSurvey
                commitAction={() => this.submit(data)}
              />
            </div>
          }
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/checker/SeoProblemsSetup.js